import { makeUseAxios } from "axios-hooks";

import { createApiFor, ExtendedUseAxios } from "./utils";

const useWishlistService = makeUseAxios({
    axios: createApiFor(`/wishlistservice`),
    defaultOptions: {
        ssr: false,
        manual: false
    }
}) as ExtendedUseAxios;

export { useWishlistService };
